/* global femcare, dataLayer */

/*
 |--------------------------------------------------------------------------
 | Google analytics events.
 |--------------------------------------------------------------------------
 |
 | Event listeners to push Google analytics events.
 |
 */

/*
 * General events
 **/

femcare.tracking.gaTracking = {
    init: function () {
        var isErrorPage = $("meta[name='keywords']").attr('content') === 'error';

        // Navigation interaction
        // Navigation Category interaction 
        $('.navigation-bar__topic, .mobile-navigation__accordion-header').on('click', function(){
            var element = $(this);
            var categoryName;

            if(element.hasClass('navigation-bar__topic')) {
                categoryName = element.find('span').text();
            } else {
                categoryName = element.find('.mobile-navigation__topic').text();
            }

            categoryName = categoryName.replace(/\s+/g, " ").trim();

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: 'NavigationMenu',
                    eventCategory: 'Top Navigation Category',
                    eventAction: categoryName,
                    eventLabel: categoryName,
                });
            }
        });

        // Navigation Sub-Category interaction 
        $('.navigation-bar__link, .mobile-navigation__link').on('click', function(){
            var subCategoryName = $(this).text().replace(/\s+/g, " ").trim();
            var category = $(this).parents('.navigation-bar__submenu, .mobile-navigation__submenu').parents('li');
            var categoryName = category.find('a span, .mobile-navigation__topic').text().replace(/\s+/g, " ").trim();

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: 'NavigationMenu',
                    eventCategory: 'Top Navigation Category',
                    eventAction: categoryName,
                    eventLabel: subCategoryName,
                });
            }
        })

        // Select language interaction 
        $('.navigation-bar__language-popout a').on('click', function () {
            var selectedLanguage = $(this).data('language');

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: 'languageSelector',
                    eventCategory: 'Navigation',
                    eventAction: 'Language Selector',
                    eventLabel: selectedLanguage
                });
            }
        });

        // Social share interaction 
        $('.share-button').on('click', function (e) {
            e.preventDefault();
            var channel = $(this).data('channel');

            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: ' socialInteraction',
                    eventCategory: 'Social Share',
                    eventAction: channel,
                    eventLabel: window.location.href
                });
            }
        });

        if (isErrorPage) {
            $(document).trigger('ga-pageError');
        }

        $('a[data-ga-title]').on('click', function (e) {
            var $link = $(this);

            window.dataLayer = window.dataLayer || [];
            window.dataLayer.push({
                event: 'gaEvent',
                eventTrigger: 'articleClick',
                eventCategory: 'Article Click',
                eventAction: $link.attr('data-ga-title'),
                eventLabel: window.location.href,
                eventValue: undefined
            });
        });          

        //attach GA event to reviews (PowerReviews and Bazaar Voice)

        $('#pr-reviewdisplay').on('click', '.pr-snippet-write-review-link' , function(e){
            var isPowerReviewsLoaded = window.POWERREVIEWS;  

            if(isPowerReviewsLoaded){
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                event: 'gaEvent',
                eventTrigger: 'Review',
                eventCategory: 'Review',
                eventAction: 'Presubmit',
                eventLabel: window.location.href
            });

                e.stopPropagation();
            }
        });
         
        $('.show-reviews-container').on('click', '.bv-write-review, .bv-first-to-review', function(e){
            var isBVLoaded = window.$BV;
            if(isBVLoaded) {
                window.dataLayer = window.dataLayer || [];
                window.dataLayer.push({
                    event: 'gaEvent',
                    eventTrigger: 'Review',
                    eventCategory: 'Review',
                    eventAction: 'Presubmit',
                    eventLabel: window.location.href
                });
                e.stopPropagation();
            }
        })
    },

    formSubmit: function ($form) {
        var eventLabel = $form.attr('data-ga-name');
        var eventTrigger = $form.attr('data-ga-trigger');

        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
            event: 'gaEvent',
            eventTrigger: eventTrigger || 'formSubmit',
            eventCategory: 'Form',
            eventAction: 'Submit',
            eventLabel: eventLabel || undefined,
            eventValue: undefined
        });
    },

    
};

/**
 * Page errors
 */
$(document).on('ga-pageError', function () {
    if (typeof dataLayer !== 'undefined') {
        dataLayer.push({
            event: 'gaEvent',
            eventTrigger: 'pageError',
            eventCategory: 'Page Error',
            eventAction: 'Error 404',
            eventLabel: document.referrer
        });
    }
});
